export function exportHtmlToDoc(
  htmlContent: string,
  filename: string = "jd.doc"
) {
  // Ensure the filename ends with `.doc`
  if (!filename.endsWith(".doc")) {
    /* eslint-disable prefer-template */
    filename.concat(".doc");
  }

  // Create a Blob with the provided HTML content
  const blob = new Blob(["\ufeff" + htmlContent], {
    type: "application/msword;charset=utf-8"
  });

  // Create a download link
  const downloadLink = document.createElement("a");
  const url = URL.createObjectURL(blob);
  downloadLink.href = url;
  downloadLink.download = filename;

  // Trigger the download
  downloadLink.click();

  // Clean up the URL object
  URL.revokeObjectURL(url);
}
